import { render, staticRenderFns } from "./modules_change.vue?vue&type=template&id=5c4e68c9&scoped=true&"
import script from "./modules_change.vue?vue&type=script&lang=js&"
export * from "./modules_change.vue?vue&type=script&lang=js&"
import style0 from "./modules_change.vue?vue&type=style&index=0&id=5c4e68c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4e68c9",
  null
  
)

export default component.exports